import { render, staticRenderFns } from "./formFields.vue?vue&type=template&id=27d510c0&scoped=true&"
import script from "./formFields.vue?vue&type=script&lang=js&"
export * from "./formFields.vue?vue&type=script&lang=js&"
import style0 from "./formFields.vue?vue&type=style&index=0&id=27d510c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d510c0",
  null
  
)

export default component.exports